import { render, staticRenderFns } from "./copy_right.vue?vue&type=template&id=2daac31e&scoped=true&"
import script from "./copy_right.vue?vue&type=script&lang=js&"
export * from "./copy_right.vue?vue&type=script&lang=js&"
import style0 from "./copy_right.vue?vue&type=style&index=0&id=2daac31e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daac31e",
  null
  
)

export default component.exports